import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import { red } from '@mui/material/colors';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  Chip,
} from "@mui/material";

const DineInOrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
const navigate = useNavigate();
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/orders/table`);
      setOrders(response.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const filteredOrders = orders.filter((order) =>
    order.orderId.toLowerCase().includes(searchTerm.toLowerCase())
  );
const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
  
    case "processing":
      return '#FFC107'; 
    case "ready for deliver":
      return '#FF9800'; 
    case "delivered":
      return '#FF6F61'; 
    
    case "complete":
      return '#2E8B57'; 
    
    case "cancelled":
      return '#f44336'; 
    default:
      return '#9E9E9E'; 
  }
};

return (
  <Box sx={{scrollbarWidth:"none"}} className="container mt-4">
   
    <Box sx={{ mb: 2 }}>
      <Typography variant="h5" gutterBottom>
        Dine-In Orders
      </Typography>


      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
        <Chip label="New Customer" sx={{ backgroundColor: '#009688', color: '#fff' }} /> 
        <Chip label="Processing" sx={{ backgroundColor: '#FFC107', color: '#fff' }} /> 
         <Chip label="Ready For deliver" color="warning" />
          <Chip label="Delivered"sx={{ backgroundColor:'#FF6F61',color: '#fff' }} />
          <Chip label="Bill Requested" sx={{ backgroundColor:'#BA55D3',color: '#fff' }} /> 
         <Chip label="Complete"sx={{ backgroundColor:'#2E8B57',color: '#fff' }} /> 
     <Chip label="Table Reservation" sx={{backgroundColor: '#CD5C5C',color: '#fff',}}/>
      </Box>

      <Box sx={{ mb: 2 }}>
        <TextField
          label="Search Order ID"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Box>
    </Box>

  
    <Box
      sx={{
        maxHeight: "70vh", 
        overflowY: "auto",
        pr: 1, scrollbarWidth:"none",
      }}
    >
      <Grid container spacing={3}>
        {filteredOrders.length === 0 ? (
          <Typography
            variant="body1"
            sx={{ textAlign: "center", color: "gray", width: "100%" }}
          >
            No orders found.
          </Typography>
        ) : (
          filteredOrders.map((order) => (
            <Grid
              item
              key={order._id}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              onDoubleClick={() => navigate(`/order/${order._id}`)}
            >
              <Card
                sx={{
                  height: "100%",
                  border: "1px solid #ccc",
                  cursor: "pointer",
                  transition: "0.3s",
                  "&:hover": {
                    boxShadow: 4,
                    borderColor: "#007bff",
                  },
                }}
              >
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Order #{order.orderId}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    Table: <strong>{order.tableNumber}</strong>
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    Status:{" "}
                    <Chip
  size="small"
  label={order.status}
  sx={{ backgroundColor: getStatusColor(order.status), color: '#fff' }}
/>

                  </Typography>
                  <Typography variant="body2">
                    Bill:{" "}
                    <strong style={{ textTransform: "capitalize" }}>
                      {order.paymentStatus}
                    </strong>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  </Box>
);


};

export default DineInOrdersPage;
